export default "__VITE_ASSET__7m5EGAlS__"